import { useState } from 'react';


import axios from 'axios';
import { Global } from '../../../Global';


import '../../../../assets/css/detalleRegistro.css';


import Error from '../../../elementos/Error';
import ButtonIcon from '../../../elementos/ButtonIcon';


import PendingIcon from '@mui/icons-material/Pending';
import DescriptionIcon from '@mui/icons-material/Description';

export default function ClientePagoVerFactura({pagoId, dominio}) {

    const [loading, setLoading] = useState(false)

    const handleClick = () => {

        setLoading(true);

        axios.get(Global.url_api + 'clientes-pagos/factura/' + dominio + '/' + pagoId, { headers: { Authorization: localStorage.getItem("token") } })
            .then(res => {

                if(res.data?.url){
                    window.open(res.data?.url, '_blank');
                    setLoading(false);
                }else{
                    throw new Error("No se encontró un token válido en la respuesta de la factura.");
                }

            })
            .catch((error) => {
                alert("Error al obtener factura");
                setLoading(false);
            });

    }


    if (loading) return (
        <ButtonIcon
            variant="outlined"
            size="small"
            color="success"
            startIcon={<PendingIcon />}
            noLink
            marginRight
        />
    )


    return (
        <ButtonIcon
            handleClick={() => handleClick()}
            variant="outlined"
            size="small"
            color="success"
            startIcon={<DescriptionIcon />}
            noLink
            marginRight
        />
    )

}